<template>
  <section id="agenzie" class="ic-home-agencies">
    <div class="ic-home-agencies__card">
      <!-- Overlapping agent avatars. Placeholder faces for now; real agent
           photos will be dropped in later. -->
      <div class="ic-home-agencies__avatars" aria-hidden="true">
        <img
          v-for="(agent, i) in agents"
          :key="i"
          class="ic-home-agencies__avatar"
          :src="agent.photo"
          :alt="agent.alt"
        />
      </div>

      <h2 class="ic-home-agencies__title">
        Sei un'agenzia?<br />Entra in immaginacasa.com
      </h2>
      <p class="ic-home-agencies__lead">
        Offri un servizio unico ai tuoi clienti. I tuoi mandati avranno una marcia in
        più e la vendita dei tuoi immobili avverrà prima che tu te ne accorga!
      </p>

      <div class="ic-home-agencies__actions">
        <a
          data-testid="agency-account"
          class="ic-home-btn"
          href="https://agenzie.immaginacasa.com/register"
          target="_blank"
          rel="noopener"
        >Crea un account</a>
        <button
          type="button"
          data-testid="agency-contact"
          class="ic-home-agencies__link"
          @click="showContact = true"
        >Richiedi un contatto</button>
      </div>
    </div>

    <!-- Same marquee (motion + dynamic width) as the one below the hero,
         reused verbatim so the two stay in sync. -->
    <home-agency-logos :logos="logos" />

    <!-- Lead-capture form, kept behind the "Richiedi un contatto" CTA. -->
    <agency-contact-popup :show="showContact" @close="showContact = false" />
  </section>
</template>

<script>
import AgencyContactPopup from '@/components/AgencyContactPopup.vue';
import HomeAgencyLogos from '@/components/home/HomeAgencyLogos.vue';
import agent1 from '@/assets/img/agency-agent-1.jpg';
import agent2 from '@/assets/img/agency-agent-2.jpg';
import agent3 from '@/assets/img/agency-agent-3.jpg';

export default {
  name: 'HomeAgencies',
  components: { AgencyContactPopup, HomeAgencyLogos },
  props: {
    // Agency logos for the marquee; same array the hero marquee receives.
    logos: { type: Array, default: () => [] },
  },
  data() {
    return {
      showContact: false,
      agents: [
        { photo: agent1, alt: 'Agente immobiliare' },
        { photo: agent2, alt: 'Agente immobiliare' },
        { photo: agent3, alt: 'Agente immobiliare' },
      ],
    };
  },
};
</script>
